var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSortIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none",
  viewBox: "0 0 14 14",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M1.192 10.308a.625.625 0 1 0-.884.884l2.5 2.5a.625.625 0 0 0 .884 0l2.5-2.5a.626.626 0 0 0-.884-.884L3.25 12.366z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M2.625.75v12.5a.625.625 0 1 0 1.25 0V.75a.625.625 0 1 0-1.25 0M12.808 3.692a.626.626 0 0 0 .884-.884l-2.5-2.5a.625.625 0 0 0-.884 0l-2.5 2.5a.625.625 0 1 0 .884.884l2.058-2.058z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11.375 13.25V.75a.625.625 0 1 0-1.25 0v12.5a.625.625 0 1 0 1.25 0"
})));
export { SvgSortIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/sortIcon.svg";